import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import '@yy/tofu-ui-react/dist/index.css';
import 'normalize.css';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

// 添加 CSRF 防护：为所有 axios 请求注入 X-YY-CSRF-TOKEN 头
axios.interceptors.request.use((config) => {
  config.headers['X-YY-CSRF-TOKEN'] = Array.from(
    { length: 32 },
    () => Math.random().toString(36).charAt(2) || '0'
  ).join('');
  return config;
});

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
